import { App } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  denyQC,
  fixSentences,
  passQC,
  setDraftDialogOpenDeny,
  setDraftDialogOpenWarn,
  warnQC,
} from "store/bailiff/draft/dialog/draft_dialog.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useDialogQC = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  const params = useParams();
  const bailiffId = params?.bailiffId;
  const slotId = params?.slotId;
  const valids = bailiffId && slotId;
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  // handle cancel deny
  const handleOpenDeny = () => {
    dispatch(setDraftDialogOpenDeny(true));
  };

  // handle cancel warn
  const handleOpenWarn = () => {
    dispatch(setDraftDialogOpenWarn(true));
  };

  // handle cancel deny
  const handleCloseDeny = (form) => {
    dispatch(setDraftDialogOpenDeny(false));
    form?.resetFields();
  };

  // handle cancel warn
  const handleCloseWarn = (form) => {
    dispatch(setDraftDialogOpenWarn(false));
    form?.resetFields();
  };

  const handleUpdateSegment = ({
    slot,
    content,
    start,
    end,
    speaker,
    setEdit = () => {},
  }) => {
    if (!valids)
      return message.error("Lỗi định dạng, vui lòng reload và thử lại");
    const id = `${bailiffId}-${slotId}`;
    if (content === "") return message.error("Không được phép để trống!");
    if (!slot) return message.error("Bạn cập nhật không đúng!");

    console.log({ slot, content, id, start, end, speaker });
    setLoading(true);
    dispatch(
      fixSentences({ id, slot, text: content, start, end, speaker }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Cập nhật thành công!");
          setEdit(false);
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  // pass qc.
  const handleRatePass = () => {
    if (!valids)
      return message.error("Lỗi định dạng, vui lòng reload và thử lại");
    const id = `${bailiffId}-${slotId}`;
    setLoading(true);
    dispatch(
      passQC({ id }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Đánh giá thành công!");
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  // deny qc.
  const handleRateFail = ({ reason, form }) => {
    if (!valids)
      return message.error("Lỗi định dạng, vui lòng reload và thử lại");
    const id = `${bailiffId}-${slotId}`;
    if (reason === "") return message.error("Vui lòng ghi rõ lý do!");
    setLoading(true);
    dispatch(
      denyQC({ id, reason }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Đánh giá thành công!");
          handleCloseDeny(form);
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  // warning qc.
  const handleRateWarn = ({ reason, form }) => {
    if (!valids)
      return message.error("Lỗi định dạng, vui lòng reload và thử lại");
    const id = `${bailiffId}-${slotId}`;
    if (reason === "") return message.error("Vui lòng ghi rõ lý do!");
    setLoading(true);
    dispatch(
      warnQC({ id, reason }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Đánh giá thành công!");
          handleCloseWarn(form);
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    loading,
    handleUpdateSegment,
    handleRatePass,
    handleRateFail,
    handleRateWarn,
    //
    handleCloseDeny,
    handleCloseWarn,
    handleOpenDeny,
    handleOpenWarn,
  };
};
